import moment from 'moment'

export default {
  //
  SET_CURRENT_SCHEDULE (state, data) {
    state.data = data
    state.date = moment()
  }
}
